import { render } from "./HelixChips.vue?vue&type=template&id=1476f505&scoped=true"
import script from "./HelixChips.vue?vue&type=script&lang=js"
export * from "./HelixChips.vue?vue&type=script&lang=js"

import "./HelixChips.vue?vue&type=style&index=0&id=1476f505&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1476f505"]])

export default __exports__